import { Component, EventEmitter, Output, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CommonService } from 'src/app/core/services/common.service';

@Component({
  selector: 'app-org-dropdown-modal',
  templateUrl: './org-dropdown-modal.component.html',
  styleUrls: ['./org-dropdown-modal.component.scss'],
})
export class OrgDropdownModalComponent implements OnInit {
  @Input() dimOrganizations: any;
  public selectedOrganization: any;
  public showConfirmation: boolean = false;
  states: any[] = [];
  @Output() organizationSelected = new EventEmitter<any>();
  searchTerm: any = '';

  constructor(private commonService: CommonService,
    public dialogRef: MatDialogRef<OrgDropdownModalComponent>
  ) { }

  ngOnInit(): void {
    this.commonService.getAllStates().subscribe((res) => this.states = res.data)
  }

  onOrganizationSelect() {
    console.log('Selected Organization:', this.selectedOrganization);
    if (this.selectedOrganization) {
      this.showConfirmation = true;
    }
  }

  customSearch = (term: string, item: any) => {
    if (!term) {
      this.selectedOrganization = '';
      return true;
    }
    this.selectedOrganization = term;
    return item.name.toLowerCase().includes(term.toLowerCase());
  };



  confirmSelection() {
    console.log('Selected Organization:', this.selectedOrganization);
    this.organizationSelected.emit(this.selectedOrganization);
    this.dialogRef.close();
    this.showConfirmation = false;
  }

  cancelSelection() {
    this.showConfirmation = false;
    this.selectedOrganization = null;
    this.dialogRef.close();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  cleanMascoText(organization: any) {
    const { institutionTypeWithMascotText, city, state } = organization
    let stateName: string;
    if (!isNaN(state)) {
      let stateData = this.states.find((st: any) => st?.id === parseInt(state));
      stateName = stateData ? stateData.name : state;
    } else stateName = state;
    return (institutionTypeWithMascotText ? (institutionTypeWithMascotText + ' - ') : '') +
      (city ? city : '') +
      (stateName ? '(' + stateName + ')' : '');
  }

  splitName(name: string): string[] {
    if (!this.selectedOrganization) return [name];
    const parts = name.split(new RegExp(`(${this.selectedOrganization})`, 'gi'));
    return parts.filter(part => part.trim() !== "");
  }

}
